/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExportAdminEarningsStatementsPdfDto { 
    /**
     * Mongo `_id` of organizer monthly invoice snapshots (max 50). Duplicates are deduplicated; merged PDF order is billingPeriodEnd desc, then issueDate desc, then snapshot id desc (not client order).
     */
    invoiceIds: Array<string>;
}

